export const iconFontAwesomeMathematicsSuperscript = (
	<i className="fa-solid fa-superscript"></i>
);
